import { Divider, ListSubheader, MenuItem, styled } from "@mui/material";

const MenuItemStyled = styled(MenuItem)(() => ({
  fontSize: "14px",
}));

export const selectOptionsRenderer = ({ option, itemRenderer }) => {
  if (typeof option === "string") {
    return (
      <MenuItemStyled key={option} value={option}>
        {option}
      </MenuItemStyled>
    );
  }
  if (itemRenderer) {
    return (
      <MenuItemStyled key={option.value} value={option?.value}>
        {itemRenderer({ option })}
      </MenuItemStyled>
    );
  }
  if (option.isDivider) {
    return <Divider key="divider" />;
  }
  return (
    <MenuItemStyled
      key={option.value}
      value={option?.value}
      disabled={option.disabled}
    >
      {option?.label}
    </MenuItemStyled>
  );
};

export const selectGroupOptionsRenderer = ({
  group,
  options,
  itemRenderer,
}) => {
  const renderGroupArray = [
    <ListSubheader key={group.value} sx={{ textAlign: "center" }}>
      {group.title}
    </ListSubheader>,
    ...options
      ?.filter((option) => option.group === group.value)
      .map((option) => {
        return selectOptionsRenderer({ option, itemRenderer });
      }),
  ];
  return renderGroupArray.map((item) => item);
};
